import React from "react";

interface Props extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  selected?: boolean;
  disabled?: boolean;
  onClear?: () => void;
}

function BaseChipWithBtn(props: Props) {
  const { selected, onClear, ...buttonProps } = props;

  return (
    <div className={`base-chip-with-btn ${props.className || ""} ${selected ? "selected" : ""} ${props.disabled ? "disabled" : ""}`}>
      {/* 메인 버튼 */}
      <button
        type="button"
        {...buttonProps}
        disabled={props.disabled}
        className="base-chip-with-btn__main"
        onMouseUp={(event) => {
          if (event.button === 1) {
            // 마우스의 휠 버튼 클릭 여부 확인
            event.currentTarget.click();
          }
        }}
      >
        {props.title}
      </button>

      {/* 선택된 상태일 때만 X 버튼 표시 */}
      {selected && onClear && (
        <button
          type="button"
          className="base-chip-with-btn__clear"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClear();
          }}
          disabled={props.disabled}
        >
          ×
        </button>
      )}
    </div>
  );
}

export default BaseChipWithBtn;
